// eslint-disable-next-line @citrite/workspace-ui/no-platform-dependency-access-under-src
import { hasFeatureCanary, workspaceConfiguration } from '@citrite/workspace-ui-platform';
import { FeatureFlag } from 'Environment/FeatureFlag';

export const shouldHaveRetries = () => {
	return hasFeatureCanary(
		workspaceConfiguration.get(),
		FeatureFlag.EnableBXTNSetCapabilitiesRetries
	);
};
